import type { Account } from '../../api/client';

export interface MessageStyleDraft {
  start_letter_policy: NonNullable<Account['start_letter_policy']>;
  speed_policy: NonNullable<Account['speed_policy']>;
  bubble_count_min: string;
  bubble_count_max: string;
  bubble_word_limit: string;
}

export function messageStyleFromAccount(account: Account): MessageStyleDraft {
  return {
    start_letter_policy: account.start_letter_policy ?? 'mixed',
    speed_policy: account.speed_policy ?? 'quick',
    bubble_count_min: String(account.bubble_count_min ?? 1),
    bubble_count_max: String(account.bubble_count_max ?? 3),
    bubble_word_limit: String(account.bubble_word_limit ?? 50),
  };
}

// SQL INTEGER upper bound; keep empty/decimal input visible for correction.
function integerError(value: string, minimum: number, error: string) {
  const number = Number(value);
  if (value.trim() === '' || !Number.isInteger(number) || number < minimum) return error;
  return number > 2147483647 ? 'tooLargeError' : null;
}

export function messageStyleErrors(value: MessageStyleDraft) {
  return {
    bubble_count_min: integerError(value.bubble_count_min, 1, 'countError'),
    bubble_count_max: integerError(value.bubble_count_max, 1, 'countError')
      ?? (Number(value.bubble_count_max) < Number(value.bubble_count_min) ? 'rangeError' : null),
    bubble_word_limit: integerError(value.bubble_word_limit, 15, 'wordError'),
  };
}

export function messageStylePayload(value: MessageStyleDraft): Partial<Account> {
  return {
    start_letter_policy: value.start_letter_policy,
    speed_policy: value.speed_policy,
    bubble_count_min: Number(value.bubble_count_min),
    bubble_count_max: Number(value.bubble_count_max),
    bubble_word_limit: Number(value.bubble_word_limit),
  };
}
